import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IsaContributionModel } from '../../Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { ProcessType } from '../../Constants/Enums/Client/DashboardFilter/ProcessType';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class IsaContributionInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, customerId: number, editAction: string, batchId: number): Promise<IsaContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/IsaContributionInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, customerId: customerId, editAction: editAction, batchId: batchId }

    return AjaxWrapper.get<IsaContributionModel, any>(url, data);
  }
  public post(subAccountHierarchyId: string, headAccountHierarchyId: string, activityType: ProcessType): Promise<ValidatedResult<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/IsaContributionInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId, activityType: activityType }

    return AjaxWrapper.post<ValidatedResult<string>, any>(url, data);
  }
  public put(model: IsaContributionModel): Promise<IsaContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/IsaContributionInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model }

    return AjaxWrapper.put<IsaContributionModel, any>(url, data);
  }
  public delete(hierarchyId: string): Promise<ServiceValidationError, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/IsaContributionInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.delete<ServiceValidationError, any>(url, data);
  }
}

